import { ButtonProps } from '@/ui/Button';

import { CtaActionButton, CtaActionButtonProps } from './CtaActionButton';
import { CtaLinkButton, CtaLinkButtonProps } from './CtaLinkButton';

export type CtaButtonProps = (
    | Omit<CtaActionButtonProps, 'variant' | 'action'>
    | Omit<CtaLinkButtonProps, 'variant' | 'url'>
) & {
    action: string | null;
    url: string | null;
    label: string;
    variant: string | null;
};

export function CtaButton({
    action,
    label,
    url,
    variant: variantProp,
    ...props
}: CtaButtonProps) {
    const [variant = 'filled', color = 'gradient'] = (variantProp?.split(':') ??
        []) as [ButtonProps['variant'], ButtonProps['color']];

    const fixedColor = color === 'red-to-purple' ? 'gradient' : color;

    if (action) {
        return (
            <CtaActionButton
                {...(props as CtaActionButtonProps)}
                action={action}
                variant={variant}
                color={fixedColor}
            >
                {label}
            </CtaActionButton>
        );
    }

    if (url) {
        return (
            <CtaLinkButton
                {...(props as CtaLinkButtonProps)}
                url={url}
                variant={variant}
                color={fixedColor}
            >
                {label}
            </CtaLinkButton>
        );
    }

    return null;
}
